import {
    alpha,
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Link as RouterLink } from "react-router-dom";
import { subscriptionBlockedMessage } from "../../config/subscriptionPlans";
import { APP_NAME } from "../../config/brand";

/** Shown on a school's public page when the director's subscription has expired. */
export default function PublicSchoolSubscriptionOverlay({ open, pageData, loginPath }) {
    if (!open || !pageData) return null;

    return (
        <Dialog open maxWidth="sm" fullWidth aria-labelledby="public-subscription-block">
            <DialogTitle id="public-subscription-block">
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box
                        sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: (t) => alpha(t.palette.warning.main, 0.15),
                            color: "warning.main",
                        }}
                    >
                        <LockOutlinedIcon />
                    </Box>
                    <Typography variant="h6" fontWeight={700}>
                        {pageData.schoolName || "This school"} — page temporarily unavailable
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {subscriptionBlockedMessage(pageData)}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Parents and visitors will see this message until the school director renews {APP_NAME}.
                    Payment confirmation removes this notice automatically.
                </Typography>
                {loginPath && (
                    <Button component={RouterLink} to={loginPath} variant="outlined" size="small">
                        School staff sign in
                    </Button>
                )}
            </DialogContent>
        </Dialog>
    );
}
